__turbopack_context__.v({
  "container": "SliderCover-module__Qdz29a__container",
  "description": "SliderCover-module__Qdz29a__description",
  "fadeInItems": "SliderCover-module__Qdz29a__fadeInItems",
  "info": "SliderCover-module__Qdz29a__info",
  "link": "SliderCover-module__Qdz29a__link",
  "mainTitle": "SliderCover-module__Qdz29a__mainTitle",
  "mainTitleContainer": "SliderCover-module__Qdz29a__mainTitleContainer",
  "media": "SliderCover-module__Qdz29a__media",
  "mediaDesktop": "SliderCover-module__Qdz29a__mediaDesktop",
  "mediaMobile": "SliderCover-module__Qdz29a__mediaMobile",
  "progressBar": "SliderCover-module__Qdz29a__progressBar",
  "progressBarIndicator": "SliderCover-module__Qdz29a__progressBarIndicator",
  "spacing--lg": "SliderCover-module__Qdz29a__spacing--lg",
  "spacing--md": "SliderCover-module__Qdz29a__spacing--md",
  "spacing--sm": "SliderCover-module__Qdz29a__spacing--sm",
  "spacing--xl": "SliderCover-module__Qdz29a__spacing--xl",
  "spacing--xs": "SliderCover-module__Qdz29a__spacing--xs",
  "spacing--xxl": "SliderCover-module__Qdz29a__spacing--xxl",
  "spacing--xxs": "SliderCover-module__Qdz29a__spacing--xxs",
  "spacing--xxxl": "SliderCover-module__Qdz29a__spacing--xxxl",
  "spacing--xxxs": "SliderCover-module__Qdz29a__spacing--xxxs",
  "title": "SliderCover-module__Qdz29a__title",
});
